import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { OutsideClickDirective } from "@directives";
import { InfoType, MenuTab } from "@models";
import { ActionService } from "@services";

import { BetsTabComponent } from "../bets-tab/bets-tab.component";
import { InfoTabComponent } from "../info-tab/info-tab.component";
import { LimitsTabComponent } from "../limits-tab/limits-tab.component";
import { MenuTabComponent } from "../menu-tab/menu-tab.component";
import { ProvablyFairTabComponent } from "../provably-fair-tab/provably-fair-tab.component";

@Component({
  selector: "mn-menu",
  styleUrls: ["./menu.component.scss"],
  templateUrl: "./menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [{ directive: OutsideClickDirective, outputs: ["outsideClick"] }],
  imports: [MenuTabComponent, LimitsTabComponent, BetsTabComponent, ProvablyFairTabComponent, InfoTabComponent],
})
export class MenuComponent {
  private readonly acS = inject(ActionService);

  protected readonly tab = computed<MenuTab>(() => this.acS.mS$()?.tab || MenuTab.M);

  protected readonly M_T = MenuTab;
  protected readonly I_T = InfoType;
}
